import { render, staticRenderFns } from "./distributionModeManage.vue?vue&type=template&id=5ccd8c8b&scoped=true"
import script from "./distributionModeManage.vue?vue&type=script&lang=js"
export * from "./distributionModeManage.vue?vue&type=script&lang=js"
import style0 from "./distributionModeManage.vue?vue&type=style&index=0&id=5ccd8c8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccd8c8b",
  null
  
)

export default component.exports